<template>
    <NavbarNotice :notice-id="NavbarNoticeId.DEMO_NOTIFICATION">
        <div class="flex gap-6">
            <IconWarning />
            <div class="flex flex-col gap-1">
                <strong class="sim-text-normal sim-font-bold sim-letters-widespread uppercase">
                    {{ $t('notices.demo_shop.title') }}
                </strong>

                <i18n-t
                    tag="p"
                    scope="global"
                    class="sim-text-normal"
                    keypath="notices.demo_shop.text"
                >
                    <template #name>
                        <strong class="sim-font-bold">
                            {{ $t('global.simploshop') }}
                        </strong>
                    </template>

                    <template #test_data>
                        <strong class="sim-font-bold">
                            {{ $t('notices.demo_shop.test_data') }}
                        </strong>
                    </template>
                </i18n-t>

                <div class="mt-4 flex gap-4 max-sm:flex-col sm:flex-wrap">

                    <BaseUiButton
                        :to="$t('links.admin')"
                        target="_blank"
                        class="uppercase"
                        color="simplo"
                        size="medium"
                        dense
                        pill
                    >
                        {{ $t('notices.demo_shop.admin') }}
                    </BaseUiButton>

                    <BaseUiButton
                        :to="$t('links.simploshop')"
                        target="_blank"
                        class="uppercase"
                        size="medium"
                        color="basic"
                        dense
                        pill
                    >
                        {{ $t('notices.demo_shop.learn_more') }}
                    </BaseUiButton>
                </div>
            </div>
        </div>
    </NavbarNotice>
</template>

<script lang="ts" setup>
import { NavbarNoticeId } from '../../../assets/ts/enums/navbar-notice'

</script>

<style lang="scss" scoped>

</style>
